import React, { useContext, useState } from 'react';
import {
    Input,
    Button,
    useToast,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Spinner
  } from '@chakra-ui/react';
import axios from "axios";
import { link_uri } from '../../../uri';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../../context/auth';
import { LINK, TYPES } from '../../../utils/type';

const LinkOrder = () => {
  const [load, setLoad] = useState(false);
  const [data, setData] = useState({image:"", link:"", note:"", end:true, fb:""});
  const [tabao, setTabao] = useState();
  const {currentUser, logout} = useContext(AuthContext);
  const toast = useToast();

  const handleUpload = (e) => {
    if (e?.size <= 5 * 1024 * 1024) {
        if (e?.type === "image/jpeg" || e?.type === "image/jpg" || e?.type === "image/png") {
            setData({...data, image:e});
        } else {
            toast({title: 'Уучлаарай',description: "Зөвхөн jpeg/png өргөтгөлтэй зураг оруулах боломжтой !",status: 'error',duration: 8000,isClosable: true,}) 
        }
    } else {
        toast({title: 'Уучлаарай',description: "Файлын хэмжээ 5MB-с бага байх ёстой!",status: 'error',duration: 8000,isClosable: true,}) 
    }
  };

  const handleSubmitPinduaodo = async () => {
    setLoad(true);
    const form = new FormData();
    form.append('image', data.image);
    form.append('link', data.link);
    form.append('stat', LINK.PIND);
    form.append('fb', data.fb);
    form.append('token', currentUser);

    try{
        const res = await axios.post(link_uri+"/create", form);
        if(res.status === 200){
            toast({title: 'Амжилттай',description: "Захиалга илгээлээ !",status: 'success',duration: 8000,isClosable: true,});
            setData({...data, image:"", link:"", note:"", end: false});
        }
        setLoad(false);
    }catch(err){
      if(err.response.status === 444){
        logout();
      }
      console.log(err);
      setLoad(false);
    }
  }

  const handleSubmitTabao = async () => {
    setLoad(true);
    const form = new FormData();
    form.append('link', data.link);
    form.append('stat', LINK.TABAO);
    form.append('token', currentUser);
    form.append('fb', data.fb);

    try{
        const res = await axios.post(link_uri+"/create", form);
        if(res.status === 200){
            toast({title: 'Амжилттай',description: "Захиалга илгээлээ !",status: 'success',duration: 8000,isClosable: true,});
            setData({...data, image:"", link:"", end: false, note:"",});
        }
        setLoad(false);
    }catch(err){
      if(err.response.status === 444){
        logout();
      }
      console.log(err);
      setLoad(false);
    }
  }
  
  if(currentUser){
    return (
      <div className='text-black mt-8'>
           <div className='flex items-center gap-4'>
              <div>
                  <h1 className='font-bold text-md uppercase text-xl'>Линк захиалга хийх</h1>
                  <p>Онлайн захиалга үүсгэх</p>
              </div>
          </div>
  
          {/* <div className='text-black mt-6'>
            <h1 className='mt-2'>Зураг оруулах *</h1>
            <Input onChange={(e) => handleUpload(e.target.files[0])} type="file" size='xs' className='ring-1 rounded-xl mt-1 w-80'/>
  
            <Button onClick={handleSubmit}>handleSubmit</Button>
          </div> */}
          {data.end ?
          <div className='mt-4 w-full font-Roboto'>
            <Tabs variant="enclosed">
              <TabList className='bg-gray-200 rounded-t-md'>
                <Tab className='w-full font-bold'>Pinduoduo линк захиалга</Tab>
                <Tab className='w-full font-bold'>Tabao линк захиалга</Tab>
              </TabList>
  
              <TabPanels>
                <TabPanel>
                  <div className='flex items-center gap-2'>
                    <img className='rounded-md w-12' src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSdiIkgjzWyfMRdvCW6QC81CRAVA-y_v3MOJA&s'/>
                    <h1>Pinduoduo</h1>
                  </div>
                  <div className='mt-4'>
                    <h1 className='text-sm'>Захиалах барааныхаа линк оруулах</h1>
                    <Input className='mt-1 border' placeholder='Линк оруулах' onChange={(e) => setData({...data, link: e.target.value})}/>

                    <h1 className='text-sm mt-3'>Барааны тэмдэглэл</h1>
                    <Input className='mt-1 border' placeholder='Утас, өмд гэх мэт' onChange={(e) => setData({...data, note: e.target.value})}/>
  
                    <div className="relative w-full mt-2">
                      <h1 className='mb-2 text-sm'>Захиалгын зураг оруулах *</h1>
                      <input
                          onChange={(e) => handleUpload(e.target.files[0])}
                          placeholder="Image"
                          className="absolute bottom-0 w-full h-full z-10 opacity-0"
                          type="file"
                          size="xs"
                      />
                      <div className='border border-dashed rounded-md p-4 bg-gray-50' onClick={handleUpload}>
                        <div className=''>
                          <div className='flex justify-center'>
                              <img className='w-12' src='https://cdn-icons-png.freepik.com/256/10024/10024501.png?semt=ais_hybrid'/>
                          </div>
                          <h1 className='text-center text-sm mt-2'>Захиалгын зураг оруулах</h1>
                        </div>
                      </div>
                      {
                        data.image?
                          <h1 className='bg-blue-600 text-white xs:text-[8px] md:text-xs md:w-24 xs:w-16 text-center rounded mt-2'>Зураг орсон</h1>
                          :
                          <h1 className='bg-blue-600 text-white xs:text-[8px] md:text-xs md:w-40 xs:w-24 text-center rounded mt-2'>Зураг оруулаагүй байна</h1>
                      }
                    </div>
  
                    {
                      load ?
                      <Button className='mt-6 w-full' bgColor='blue' color='white'>
                        <Spinner color='white'/>
                      </Button>
                      :
                      <Button className='mt-6 w-full' bgColor='blue' color='white' onClick={handleSubmitPinduaodo}>Захиалга үүсгэх</Button>
                    }
                  </div>
                </TabPanel>
  
                <TabPanel>
                  <div className='flex items-center gap-2'>
                    <img className='rounded-md w-12' src='https://cdn4.iconfinder.com/data/icons/chinas-social-share-icons/256/cssi_taobao-512.png'/>
                    <h1>Tabao</h1>
                  </div>
                  <div className='mt-4'>
                    <h1 className='text-sm'>Захиалах барааныхаа линк оруулах</h1>
                    <Input className='mt-2' placeholder='Линк оруулах' onChange={(e) => setData({...data, link: e.target.value})}/>

                    <h1 className='text-sm mt-3'>Барааны тэмдэглэл</h1>
                    <Input className='mt-1 border' placeholder='Утас, өмд гэх мэт' onChange={(e) => setData({...data, note: e.target.value})}/>
  
                    {
                      load ?
                      <Button className='mt-6 w-full' bgColor='blue' color='white'>
                        <Spinner color='white'/>
                      </Button>
                      :
                      <Button className='mt-6 w-full' bgColor='blue' color='white' onClick={handleSubmitTabao}>Захиалга үүсгэх</Button>
                    }
  
                  </div>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </div>
          :
          <div>
            <div className='flex justify-center'>
              <img className='w-20 mt-2' src='../../icons/icons8-success.gif'/>
            </div>
            <h1 className='mt-3 font-bold text-center'>Амжилттай таны мэдээллийг шалгаад манай админ холбогдох болно !</h1>
            <Button className='mt-3 w-full border' onClick={(e)=> setData({...data, end:true})}>Дахин захиалга өгөх</Button>
          </div>
        }
      </div>
    );
  }else{
    return <Navigate to='/login'/>
  }
}

export default LinkOrder
